import { render, staticRenderFns } from "./TaskDetailEditTabPanel.vue?vue&type=template&id=9008f5b4"
import script from "./TaskDetailEditTabPanel.vue?vue&type=script&lang=js"
export * from "./TaskDetailEditTabPanel.vue?vue&type=script&lang=js"
import style0 from "./TaskDetailEditTabPanel.vue?vue&type=style&index=0&id=9008f5b4&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9008f5b4')) {
      api.createRecord('9008f5b4', component.options)
    } else {
      api.reload('9008f5b4', component.options)
    }
    module.hot.accept("./TaskDetailEditTabPanel.vue?vue&type=template&id=9008f5b4", function () {
      api.rerender('9008f5b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/preScreening/taskDetail/TaskDetailEditTabPanel.vue"
export default component.exports